import { api, userTimezone } from "@/lib/api";
import { isIOS, isStandalone } from "@/lib/pwa";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const needsHomeScreen = () => isIOS() && !isStandalone();
export const permission = () => (pushSupported() ? Notification.permission : "unsupported");

const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

const registration = () => navigator.serviceWorker.register("/sw.js").then(() => navigator.serviceWorker.ready);

async function subscribeAndSave() {
  const reg = await registration();
  const { data } = await api.get("/push/key");
  const key = toKey(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  const subKey = sub?.options?.applicationServerKey;
  if (sub && subKey && new Uint8Array(subKey).join() !== key.join()) {
    await sub.unsubscribe().catch(() => {});
    sub = null;
  }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys, timezone: userTimezone() });
  return sub;
}

export async function enablePush() {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error(perm === "denied" ? "Notifications are blocked. Allow them for Roll SmartR in your phone settings." : "Permission wasn't granted.");
  return subscribeAndSave();
}

export async function syncPush() {
  if (!pushSupported() || needsHomeScreen() || Notification.permission !== "granted") return false;
  await subscribeAndSave();
  return true;
}

export async function disablePush() {
  await api.post("/push/unsubscribe", {});
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  await sub?.unsubscribe().catch(() => {});
}
